import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33899062"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-edit-table-tab-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "padding" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserEditTableTab = _resolveComponent("UserEditTableTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.namesInternal, (columnGroupName) => {
      return (_openBlock(), _createBlock(_component_UserEditTableTab, {
        key: columnGroupName.i,
        label: columnGroupName.d,
        active: columnGroupName.i === _ctx.selectedTab,
        "on-select": () => _ctx.onSelectTab(columnGroupName.i)
      }, null, 8, ["label", "active", "on-select"]))
    }), 128)),
    _hoisted_2
  ]))
}